// Microsoft-only conversion mapping. Never forward attribution or form values.
// Keep legacy GA4/PostHog/LinkedIn names unchanged in analytics.js.
const CONTACT_CHANNELS = new Set(['program', 'engineering', 'quality', 'general']);

export function uetSection(pathname = '') {
  if (pathname === '/energetics' || pathname.startsWith('/energetics/')) return 'energetics';
  if (pathname === '/mounts-mechanical' || pathname.startsWith('/mounts/')) return 'mounts';
  if (pathname === '/contact-us' || pathname === '/contact') return 'contact';
  return 'other';
}

export function microsoftConversions(name, props = {}, pathname = '') {
  const section = uetSection(pathname);
  const events = [];
  const add = (action, label, category = section) => events.push({
    action, params: { event_category: category, event_label: label }
  });
  // Only explicit, confirmed-success form events qualify. A generic lead_submit
  // also fires for NSN searches and newsletter captures, so it is not mapped.
  if (name === 'rfq_submit' && props.completed === true) {
    const custom = props.inquiry_kind === 'custom_cartridge';
    add('rfq_submit', custom ? 'custom_cartridge' : 'rfq');
    if (section === 'energetics') add('energetics_rfq_submit', 'rfq');
    if (custom) add('custom_cartridge_inquiry', 'custom_cartridge');
  } else if (name === 'contact_submit' && props.completed === true) {
    const channel = CONTACT_CHANNELS.has(props.inquiry_channel) ? props.inquiry_channel : 'general';
    const custom = channel === 'engineering' && props.inquiry_kind === 'custom_cartridge';
    add('submit_lead_form', channel);
    if (channel === 'engineering') add('engineering_inquiry', 'engineering');
    if (channel === 'program') add('program_office_inquiry', 'program');
    if (custom) add('custom_cartridge_inquiry', 'custom_cartridge', 'energetics');
  } else if (name === 'spec_pdf_request' && props.completed === true && props.product === 'm192') {
    // The legacy event also fires when opening the modal. That is not a conversion.
    add('spec_request', 'm192');
  }
  return events;
}

export function pushMicrosoftEvent(action, params) {
  if (typeof window === 'undefined') return;
  try {
    window.uetq = window.uetq || [];
    window.uetq.push('event', action, params);
  } catch (_) {
    // Analytics must never interrupt a successful inquiry or native link action.
  }
}

export function trackMicrosoftConversion(name, props = {}) {
  if (typeof window === 'undefined') return;
  microsoftConversions(name, props, window.location.pathname).forEach(({ action, params }) => pushMicrosoftEvent(action, params));
}

export function installMicrosoftLinkTracking(doc = document) {
  const onClick = event => {
    if (event.defaultPrevented || (event.button !== undefined && event.button !== 0)) return;
    const target = event.target?.closest ? event.target : event.target?.parentElement;
    const anchor = target?.closest('a[href]');
    if (!anchor) return;
    const href = (anchor.getAttribute('href') || '').trim().toLowerCase();
    const action = href.startsWith('tel:') ? 'phone_click' : href.startsWith('mailto:') ? 'email_click' : null;
    if (!action) return;
    pushMicrosoftEvent(action, {
      event_category: uetSection(window.location.pathname),
      event_label: action === 'phone_click' ? 'telephone' : 'email'
    });
  };
  doc.addEventListener('click', onClick);
  return () => doc.removeEventListener('click', onClick);
}
